import ReduxHooks from '../../../../store/ReduxHooks';
import { ApiTag } from '../../../api/ApiSlice';
import PrintersApi from '../../../api/PrinterManager';

/**
 * The native app owns printer CRUD against the same /staff/printers endpoint, so a
 * pairing, a paper width edit, a promotion or a deletion all happen behind the portal's
 * back. This says only that the list moved — the cache refetches it.
 */
export default class PrintersUpdatedHandler {
  static type = 'PRINTERS_UPDATED';

  payload = null;

  constructor(payload) {
    this.payload = payload;
  }

  notify() {
    ReduxHooks.dispatch(PrintersApi.util.invalidateTags([ApiTag.Printers]));
  }
}
